import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import {
  MALE,
  FEMALE,
  LARGE_VIEWPORT,
  viewportPropType
} from "../../state/modules/layout";
import { focusPrimaryNavigationFor } from "../../globalEventHandler";
import withTranslation from "../translation";
import styles from "./FloorNavigation.css";

const cx = classnames.bind(styles);

class FloorNavigation extends PureComponent {
  handleFemaleClick = () => {
    this.setGender(FEMALE);
  };

  handleMaleClick = () => {
    this.setGender(MALE);
  };

  setGender(gender) {
    this.props.setGender(gender);
    focusPrimaryNavigationFor(gender);
  }

  isSelected(gender) {
    const { isFemale, isMale, viewport } = this.props;

    if (gender === MALE) {
      return isMale;
    }

    if (viewport === LARGE_VIEWPORT) {
      return isFemale;
    }

    return !isMale;
  }

  render() {
    const {
      formatTranslation,
      menStoreUrl,
      womenStoreUrl,
      viewport,
      viewable
    } = this.props;

    const MenuTagType = viewport === LARGE_VIEWPORT ? "a" : "button";
    const womenMenuActionProp =
      viewport === LARGE_VIEWPORT
        ? { href: womenStoreUrl }
        : { onClick: this.handleFemaleClick };
    const menMenuActionProp =
      viewport === LARGE_VIEWPORT
        ? { href: menStoreUrl }
        : { onClick: this.handleMaleClick };

    return (
      <ul
        className={cx(styles.container, {
          [styles.container__large]: viewable.includes(LARGE_VIEWPORT)
        })}
        data-testid="floornav"
        role={"tablist"}
      >
        <li>
          <MenuTagType
            className={cx(styles.button, {
              [styles.selected]: this.isSelected(FEMALE)
            })}
            id="women-floor"
            data-testid="women-floor"
            {...womenMenuActionProp}
            aria-label={formatTranslation("header_womens_products_aria_label")}
            aria-selected={this.isSelected(FEMALE)}
            role={"tab"}
          >
            {formatTranslation("header_women_floor")}
          </MenuTagType>
        </li>
        <li>
          <MenuTagType
            className={cx(styles.button, {
              [styles.selected]: this.isSelected(MALE)
            })}
            id="men-floor"
            data-testid="men-floor"
            {...menMenuActionProp}
            aria-label={formatTranslation("header_mens_products_aria_label")}
            aria-selected={this.isSelected(MALE)}
            role={"tab"}
          >
            {formatTranslation("header_men_floor")}
          </MenuTagType>
        </li>
      </ul>
    );
  }
}

FloorNavigation.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  isFemale: PropTypes.bool,
  isMale: PropTypes.bool,
  setGender: PropTypes.func.isRequired,
  viewport: viewportPropType,
  menStoreUrl: PropTypes.string.isRequired,
  womenStoreUrl: PropTypes.string.isRequired,
  viewable: PropTypes.arrayOf(viewportPropType)
};

FloorNavigation.defaultProps = {
  isFemale: false,
  isMale: false,
  viewable: []
};

export default withTranslation(FloorNavigation);
